import { useMediaQuery, useTheme } from '@mui/material';

/** Matches the shared navigation shell: mobile header below the desktop drawer breakpoint. */
export const useIsMobileShell = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};
